import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styles: [],
})
export class PublicComponent {
  getImage = () => "url('assets/images/bg.png')";
}
